import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ToasterService } from '../toastr/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(protected toasterService: ToasterService) {}

  handleError(error: HttpErrorResponse | Error): void {
    let message: any;

    console.log('error', error)
    if ((error as HttpErrorResponse).status === 400) {
      message = this.handleBadRequest(error as HttpErrorResponse).message;
    } else if(typeof error == 'string') {
      message = error;
    } else {
      message = error.message || 'Error Occurred. Please try again.';
    }

    this.toasterService.show({
      message,
      type: 'error',
    });
  }

  private handleBadRequest(error: HttpErrorResponse): {
    message: string;
  } {
    return {
      message: error.error,
    };
  }
}
